import sharedModule from '../../shared.module';

class asImageOverlay {
    constructor(imageHelper) {
        this.imageHelper = imageHelper;
        this.clear();
    }

    clear() {
        this.src = null;
        this.busy = false;
    }

    render(src) {
        this.clear();
        this.src = src;
        this.busy = true;
    }
}

export default sharedModule.service('asImageOverlay', asImageOverlay);



// WEBPACK FOOTER //
// ./modules/shared/services/asImageOverlay/asImageOverlay.service.js